var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPictoHistorique(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 56.913,
    height: 56.913,
    viewBox: "0 0 56.913 56.913",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_36",
    "data-name": "Rectangle 36",
    width: 56.913,
    height: 56.913,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_52",
    "data-name": "Groupe 52",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_79",
    "data-name": "Trac\\xE9 79",
    d: "M28.456,56.913A28.489,28.489,0,0,1,0,28.456a.534.534,0,1,1,1.067,0,27.385,27.385,0,1,0,5.222-16.09.534.534,0,0,1-.863-.628,28.457,28.457,0,1,1,23.03,45.173",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_80",
    "data-name": "Trac\\xE9 80",
    d: "M13.432,18.35,2.6,25.106,2.162,12.345Z",
    transform: "translate(-0.846 -4.831)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_81",
    "data-name": "Trac\\xE9 81",
    d: "M48.451,50.879a.711.711,0,0,1-.332-.083l-12.472-6.6V28.469a.711.711,0,1,1,1.423,0V43.336l11.715,6.2a.712.712,0,0,1-.334,1.34",
    transform: "translate(-13.949 -10.862)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictoHistorique);
export default __webpack_public_path__ + "static/media/picto_historique.01d16f79939c9a3dc8b7285c17981a44.svg";
export { ForwardRef as ReactComponent };